import React, { useEffect, useState } from 'react'
import './styles.scss'
import CountUp from 'react-countup'

const f = new Intl.NumberFormat('de-CH')

interface Props {
  timeInRoom: number
  criticalDose: number
  result: number[]
  isMobile: boolean
}

export const Sticky = ({
  result,
  timeInRoom,
  criticalDose = 500,
  isMobile
}: Props) => {
  const [time, setTime] = useState(timeInRoom)
  useEffect(() => {
    setTime(timeInRoom)
  }, [timeInRoom])
  const isinfected = +timeInRoom >= result[1]
  const timeUntilCritical = result[1]
  const maxTime = 720
  const virusCount = +result[0].toFixed(0)
  const virusTime = +timeUntilCritical.toFixed(0)
  const text = isinfected ? (
    <>
      Eine Infektion ist <b>wahrscheinlich.</b>
    </>
  ) : (
    <>
      Eine Infektion ist eher <b>unwahrscheinlich.</b>
    </>
  )
  console.log('timeUntilCritical', timeUntilCritical >= maxTime)
  return (
    <div className='Sticky'>
      <div className={isMobile ? '' : 'ui text container'}>
        <div className={'content ' + (isinfected ? 'inf' : '')}>
          <div className='text'>{text}</div>
          <div className='factwrapper'>
            <div className='fact'>
              <b>
                <CountUp
                  end={virusCount}
                  duration={1}
                  formattingFn={n => (n > 9999 ? f.format(n) : n + '')}
                  preserveValue
                />
              </b>
              <label>
                {' '}
                eingeatmete Viren nach {time} Minuten{isMobile ? '.' : ''}
              </label>
            </div>
            <div className='fact'>
              <b>
                <CountUp
                  end={virusTime}
                  duration={1}
                  formattingFn={n => {
                    return timeUntilCritical >= maxTime
                      ? `mehr als 12 Stunden`
                      : `${f.format(n)} Minuten`
                  }}
                  preserveValue
                />
              </b>
              <label>
                {' '}
                im Raum bis zur kritischen Dosis von{' '}
                <b className='nobg'>
                  {f.format(criticalDose)} Viren{isMobile ? '.' : ''}
                </b>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
